module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img_m.f37b371b61be069433e376f2ca8e4ada.jpg";